import React, { useMemo } from "react";
import useActionsCount from "../../../hooks/data/useActionCount";
import Pill from "../../common/Pill/Pill";
import Spinner from "../../common/Spinner/Spinner";

const ActionCount = () => {
    const { count, isLoading } = useActionsCount();

    const num = useMemo(() => {
        if (isLoading) {
            return <Spinner />;
        }

        if (count > 99) {
            return "99+";
        }

        return count;
    }, [count, isLoading]);

    return <Pill>{num}</Pill>;
};

export default ActionCount;
